import { render, staticRenderFns } from "./learn.trainee.layout.vue?vue&type=template&id=74475ee0&scoped=true&"
import script from "./learn.trainee.layout.vue?vue&type=script&lang=js&"
export * from "./learn.trainee.layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74475ee0",
  null
  
)

export default component.exports